import { PepperStoneLogo, Spinner } from "../Icons";

export const Loader = ({
  removePadding = false,
}: {
  removePadding?: boolean;
}) => (
  <div
    className={`z-50 flex items-center justify-center ${removePadding ? "pt-20" : "py-20"}`}
    data-testid="loader"
  >
    <div className="relative">
      <Spinner className="h-24 w-24 animate-spin rounded-full" />
      <div className="absolute inset-0 flex items-center justify-center">
        <PepperStoneLogo />
      </div>
    </div>
  </div>
);
